module.exports = __webpack_public_path__ + "static/media/Screenshot_6.8d7c8bb0.png";